var TRIGGER_SELECTOR = 'modal-trigger';
function initTrigger(triggerNode) {
    var modalId = triggerNode.dataset.target;
    if (!modalId) {
        return;
    }
    var modalNode = document.getElementById(modalId);
    if (!modalNode) {
        return;
    }
    triggerNode.addEventListener('click', function (event) {
        event.preventDefault();
        modalNode.classList.add('!flex');
    });
    var closeNodes = Array.from(modalNode.querySelectorAll("[data-close-modal]"));
    closeNodes.forEach(function (closeNode) {
        closeNode.addEventListener('click', function (event) {
            event.preventDefault();
            modalNode.classList.remove('!flex');
        });
    });
}
export function modalInit() {
    var triggerNodes = Array.from(document.querySelectorAll("[data-js-selector='".concat(TRIGGER_SELECTOR, "']")));
    triggerNodes.forEach(function (triggerNode) {
        initTrigger(triggerNode);
    });
}
